import { TSupplierFeature } from "@/api";

export const SUPPLIER_FEATURES: TSupplierFeature[] = [
  {
    key: "ai",
    name: "AI",
    enabled: false,
    children: [
      {
        key: "ai.tania",
        name: "Tania",
        enabled: false,
        children: [
          {
            key: "ai.tania.conversations",
            name: "Conversations",
            enabled: false,
          },
          {
            key: "ai.tania.documents",
            name: "Documents",
            enabled: false,
          },
          {
            key: "ai.tania.agents",
            name: "Agents",
            enabled: false,
          },
          {
            key: "ai.tania.metrics",
            name: "Metrics",
            enabled: false,
          },
        ],
      },
      {
        key: "ai.analytics",
        name: "Analytics",
        enabled: false,
        children: [
          {
            key: "ai.analytics.widget",
            name: "Analytics Widget",
            enabled: false,
          },
        ],
      },
    ],
  },
  {
    key: "catalog",
    name: "Catalog",
    enabled: false,
  },
  {
    key: "menu",
    name: "MENU",
    enabled: false,
    children: [
      {
        key: "menu.analytics",
        name: "Analytics & Reports",
        enabled: false,
        children: [
          {
            key: "menu.analytics.dashboard",
            name: "Dashboard",
            enabled: false,
          },
        ],
      },
      {
        key: "menu.orders_management",
        name: "Dispatch",
        enabled: false,
        children: [
          {
            key: "menu.orders_management.orders",
            name: "Dispatch",
            enabled: false,
          },
          {
            key: "menu.orders_management.dispatch_routes",
            name: "Dispatch Routes",
            enabled: false,
          },
          {
            key: "menu.orders_management.loads",
            name: "Loads",
            enabled: false,
          },
        ],
      },
      {
        key: "menu.purchase_management",
        name: "Sales",
        enabled: false,
        children: [
          {
            key: "menu.purchase_management.purchases",
            name: "Orders",
            enabled: false,
          },
          {
            key: "menu.purchase_management.quotations",
            name: "Quotations",
            enabled: false,
          },
          {
            key: "menu.purchase_management.acquisitions",
            name: "My purchases",
            enabled: false,
          },
        ],
      },
      {
        key: "menu.product_management",
        name: "Product Master",
        enabled: false,
        children: [
          {
            key: "menu.product_management.products",
            name: "Products",
            enabled: false,
          },
          {
            key: "menu.product_management.curves",
            name: "Curves",
            enabled: false,
          },
          {
            key: "menu.product_management.splits",
            name: "Splits",
            enabled: false,
          },
          {
            key: "menu.product_management.categories",
            name: "Categories",
            enabled: false,
          },
          {
            key: "menu.product_management.brands",
            name: "Brands",
            enabled: false,
          },
        ],
      },
      {
        key: "menu.client_management",
        name: "Client Management",
        enabled: false,
        children: [
          {
            key: "menu.client_management.clients",
            name: "Clients",
            enabled: false,
          },
          {
            key: "menu.client_management.contacts",
            name: "Contacts",
            enabled: false,
          },
          {
            key: "menu.client_management.commercial_routes",
            name: "Commercial Routes",
            enabled: false,
          },
          {
            key: "menu.client_management.segments",
            name: "Segments",
            enabled: false,
          },
          {
            key: "menu.client_management.credits",
            name: "Credit Limits",
            enabled: false,
          },
          {
            key: "menu.client_management.commercial_tracking",
            name: "Follow up",
            enabled: false,
          },
        ],
      },
      {
        key: "menu.bulk_loads",
        name: "Bulk Loads",
        enabled: false,
      },
      {
        key: "menu.user_management",
        name: "System Users",
        enabled: false,
        children: [
          {
            key: "menu.user_management.commercials",
            name: "Staff",
            enabled: false,
          },
        ],
      },
      {
        key: "menu.payments",
        name: "Payments",
        enabled: false,
      },
      {
        key: "menu.marketing_promotions",
        name: "Marketing",
        enabled: false,
        children: [
          {
            key: "menu.marketing_promotions.lists",
            name: "Lists",
            enabled: false,
          },
          {
            key: "menu.marketing_promotions.campaigns",
            name: "Campaigns",
            enabled: false,
          },
          {
            key: "menu.marketing_promotions.channels",
            name: "Channels",
            enabled: false,
          },
        ],
      },
      {
        key: "menu.customer_service",
        name: "Customer Service",
        enabled: false,
        children: [
          {
            key: "menu.customer_service.queue",
            name: "Configuration",
            enabled: false,
          },
          {
            key: "menu.customer_service.agents",
            name: "Agents",
            enabled: false,
          },
          {
            key: "menu.customer_service.conversations",
            name: "Conversations",
            enabled: false,
          },
        ],
      },
    ],
  },
];
